import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "section-to-print",
  ref: "sectionPrint",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "btn print-btn" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Print ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Close ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HotelVoucher = _resolveComponent("HotelVoucher")!
  const _component_MealplanVoucher = _resolveComponent("MealplanVoucher")!
  const _component_TaxiVoucher = _resolveComponent("TaxiVoucher")!
  const _component_RefreshmentVoucher = _resolveComponent("RefreshmentVoucher")!
  const _component_MCVoucher = _resolveComponent("MCVoucher")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_StyledVoucher = _resolveComponent("StyledVoucher")!

  return (_openBlock(), _createBlock(_component_StyledVoucher, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_HotelVoucher, {
          "hotel-data": _ctx.VoucherData[1],
          "hotel-language": _ctx.LanguageVoucher[1],
          "pax-info": _ctx.paxThisIsMe,
          "show-second-language": _ctx.showSecondLanguage,
          "lang-pax-direction": _ctx.langPaxDirection
        }, null, 8, ["hotel-data", "hotel-language", "pax-info", "show-second-language", "lang-pax-direction"]),
        _createVNode(_component_MealplanVoucher, {
          "mealplan-language": _ctx.LanguageVoucher[23],
          "mealplan-data": _ctx.VoucherData[23],
          "pax-info": _ctx.paxThisIsMe,
          "show-second-language": _ctx.showSecondLanguage
        }, null, 8, ["mealplan-language", "mealplan-data", "pax-info", "show-second-language"]),
        _createVNode(_component_TaxiVoucher, {
          "taxi-language": _ctx.LanguageVoucher[4],
          "taxi-data": _ctx.VoucherData[4],
          "pax-info": _ctx.paxThisIsMe,
          "show-second-language": _ctx.showSecondLanguage
        }, null, 8, ["taxi-language", "taxi-data", "pax-info", "show-second-language"]),
        _createVNode(_component_RefreshmentVoucher, {
          "refreshment-language": _ctx.LanguageVoucher[2],
          "refreshment-data": _ctx.VoucherData[2],
          "pax-info": _ctx.paxThisIsMe,
          "show-second-language": _ctx.showSecondLanguage
        }, null, 8, ["refreshment-language", "refreshment-data", "pax-info", "show-second-language"]),
        _createVNode(_component_MCVoucher, {
          "mc-language": _ctx.LanguageVoucher[21],
          "mc-data": _ctx.VoucherData[21],
          "pax-info": _ctx.paxThisIsMe,
          "show-second-language": _ctx.showSecondLanguage
        }, null, 8, ["mc-language", "mc-data", "pax-info", "show-second-language"])
      ], 512),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          round: "",
          class: "btn-select",
          onClick: _ctx.handlePrint
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_4,
        _createVNode(_component_el_button, {
          round: "",
          class: "btn-select btn-close",
          onClick: _ctx.handleClose
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}